import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-nav-brand',
    templateUrl: './nav-brand.component.html',
    styleUrls: ['./nav-brand.component.scss'],
    imports: [RouterLink]
})
export class NavBrandComponent  {


}
